import type { CustomerConfig } from "../../types";

export const bmwConfig: CustomerConfig = {
	id: "bmw",
	name: "Bayerische Motoren Werke",
	shortName: "BMW",
	accessTokens: ["df7c4e8bae2dac02c99748aca0f7408a"],
	accessExpiry: new Date("2026-12-31T23:59:59Z"),
	onsiteDates: "TBD",
	theme: {
		accentColor: "#0166B1",
		accentColorLight: "#5BB4E5",
		secondaryAccent: "#6F6F6F",
		pathColorFrom: "#0166B1",
		pathColorTo: "#5BB4E5",
		slideAccentBar: "#0166B1",
	},
	logos: {
		customer: "/assets/logos/bmw.png",
		null: "/null/logo.white.svg",
	},
	demoUrl: "https://app.dev.null.autos",
	demoLabel: "Launch Null Autos Platform",
	confidentialityNotice:
    "CONFIDENTIAL — Any disclosure, use, reproduction, or distribution of this information without the express written consent of Null Autos is strictly prohibited.",
};
